import { FC } from 'react';
import { Tooltip, IconButton, IconButtonProps } from '@mui/material';
import { Icon } from '@mdi/react';
import { useCopy } from './utils';

type Props = {
  text: string;
  iconSize?: 1 | 0.5;
};

/**
 * @summary - Иконка-кнопка или кнопка для копирования.
 *
 * @param text - Текст, который нужно скопировать.
 * @param iconSize - Размер для mdi иконки. Использовать либо по умолчанию либо 0.5.
 * Нужно для одноборазия.
 */
export const CopyIcon: FC<Props & IconButtonProps> = ({ text, iconSize = 1, ...rest }) => {
  const { copy, title, colorIcon, path, copyState } = useCopy(text);

  return (
    <Tooltip title={title} arrow>
      <span>
        <IconButton
          color={copyState === 0 ? undefined : colorIcon}
          onClick={(event) => {
            copy();
            event.stopPropagation();
          }}
          onDoubleClick={copy}
          {...rest}
        >
          <Icon path={path} size={iconSize} />
        </IconButton>
      </span>
    </Tooltip>
  );
};
